require('./dist/smart-table.js');
module.exports = 'smart-table';


//////////////////
// WEBPACK FOOTER
// ./~/angular-smart-table/index.js
// module id = 246
// module chunks = 0